import React, { FC, ReactNode } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ExtensionBadge from '~/components/atoms/ExtensionBadge';
import MainLayoutSidebarDesktop from '~/components/layouts/MainLayout/components/MainLayoutSidebar/Desktop';
import { SideBarItemType } from '~/core/sidebar';
import analytics from '~/services/analytics';
import extension from '~/services/Extension';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  sidebarGroups: SideBarItemType[][];
  children?: React.ReactNode;
  sidebar?: ReactNode;
  header?: ReactNode;
};

const DesktopExtension: FC<Props> = ({
  children,
  sidebarGroups,
  sidebar,
  header,
}) => {
  const { t } = useTranslation('general');

  return (
    <div className={styles.layout}>
      <div className={styles.layout__sidebar}>
        {sidebar ?? <MainLayoutSidebarDesktop items={sidebarGroups} />}
      </div>

      <div className={styles.layout__main}>
        {header ?? (
          <div className={styles.header}>
            <Typography
              variant={Typographies.TITLE_LARGE}
              component="div"
              className={styles.header__title}
            >
              {t('sidebar:extension_v1', {
                extension_name: extension.getTitle(),
                defaultValue: '{{extension_name}} Extension',
              })}
            </Typography>

            <ExtensionBadge
              text={t('general:enable_in_extension', {
                extension: extension.getTitle(),
                defaultValue: 'Enable in {{extension}}',
              })}
              onClick={() => {
                analytics.trackEvent(
                  'navigation - click extension platform page',
                  {
                    button_name: 'Enable in Chrome',
                  },
                );
              }}
            />
          </div>
        )}

        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

export default DesktopExtension;
